// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_bank from "../../commonapis/gen/buhta_common_v1_bank.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const ListBanksRequest = Caml_module.init_mod([
      "proto/dictapis/gen/buhta_dict_v1_bank_service.ml",
      284,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListBanksResponse = Caml_module.init_mod([
      "proto/dictapis/gen/buhta_dict_v1_bank_service.ml",
      340,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.dict.v1.ListBanksRequest";
}

function make(param) {
  
}

function merge(param, param$1) {
  
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
    });

function to_proto$p(writer, param) {
  Curry._1(serialize, writer);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize, writer);
  return writer;
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1.ListBanksRequest", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1.ListBanksRequest", Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListBanksRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.dict.v1.ListBanksResponse";
}

function make$1(banksOpt, param) {
  const banks = banksOpt !== undefined ? banksOpt : /* [] */0;
  return {
          banks: banks
        };
}

const $$let = Buhta_commonapis__Buhta_common_v1_bank.Buhta.Common.V1.Bank;

const merge_banks = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "banks",
            "banks"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$1(t1, t2) {
  return {
          banks: Curry._2(merge_banks, t1.banks, t2.banks)
        };
}

function spec(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_bank.Buhta.Common.V1.Bank;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "banks",
                    "banks"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.banks);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor(banks) {
  return {
          banks: banks
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1.ListBanksResponse", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.banks);
  };
}

function constructor$1(banks) {
  return {
          banks: banks
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1.ListBanksResponse", spec(undefined), constructor$1);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListBanksResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

const listBanks_0 = {
  name: ListBanksRequest.name,
  make: ListBanksRequest.make,
  from_proto: ListBanksRequest.from_proto,
  from_proto_exn: ListBanksRequest.from_proto_exn,
  to_proto: ListBanksRequest.to_proto,
  to_proto$p: ListBanksRequest.to_proto$p,
  merge: ListBanksRequest.merge,
  to_json: ListBanksRequest.to_json,
  from_json_exn: ListBanksRequest.from_json_exn,
  from_json: ListBanksRequest.from_json
};

const listBanks_1 = {
  name: ListBanksResponse.name,
  make: ListBanksResponse.make,
  from_proto: ListBanksResponse.from_proto,
  from_proto_exn: ListBanksResponse.from_proto_exn,
  to_proto: ListBanksResponse.to_proto,
  to_proto$p: ListBanksResponse.to_proto$p,
  merge: ListBanksResponse.merge,
  to_json: ListBanksResponse.to_json,
  from_json_exn: ListBanksResponse.from_json_exn,
  from_json: ListBanksResponse.from_json
};

const listBanks = [
  listBanks_0,
  listBanks_1
];

const V1_BankService = {
  ListBanks: {
    name: "/buhta.dict.v1.BankService/ListBanks",
    package_name: "buhta.dict.v1",
    service_name: "BankService",
    method_name: "ListBanks",
    $$Request: {
      name: ListBanksRequest.name,
      make: ListBanksRequest.make,
      from_proto: ListBanksRequest.from_proto,
      from_proto_exn: ListBanksRequest.from_proto_exn,
      to_proto: ListBanksRequest.to_proto,
      to_proto$p: ListBanksRequest.to_proto$p,
      merge: ListBanksRequest.merge,
      to_json: ListBanksRequest.to_json,
      from_json_exn: ListBanksRequest.from_json_exn,
      from_json: ListBanksRequest.from_json
    },
    $$Response: {
      name: ListBanksResponse.name,
      make: ListBanksResponse.make,
      from_proto: ListBanksResponse.from_proto,
      from_proto_exn: ListBanksResponse.from_proto_exn,
      to_proto: ListBanksResponse.to_proto,
      to_proto$p: ListBanksResponse.to_proto$p,
      merge: ListBanksResponse.merge,
      to_json: ListBanksResponse.to_json,
      from_json_exn: ListBanksResponse.from_json_exn,
      from_json: ListBanksResponse.from_json
    }
  },
  listBanks: listBanks
};

const V1 = {
  ListBanksRequest: ListBanksRequest,
  ListBanksResponse: ListBanksResponse,
  BankService: V1_BankService
};

const Dict = {
  V1: V1
};

const Buhta = {
  Dict: Dict
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* ListBanksRequest Not a pure module */
